import React from 'react';
import { Box, Typography, Container, Button, Link, Grid, useTheme } from '@mui/material';

import config from '../../config/config';
import PopupModal from '../auth/PopupModal';

const ContactInfo = () => {
    const theme = useTheme();
    const [activePopup, setActivePopup] = React.useState(null);
    const handlePopupClose = () => {
        setActivePopup(null);
    };

    const handlePopupOpen = (popupName) => {
        setActivePopup(popupName);
    };
    return (
        <Box sx={{ backgroundColor: 'grey.A100', padding: theme.spacing(8, 2) }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Contact Info Section */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: 2 }}>
                            Get In Touch
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            If you have any questions or need assistance, feel free to reach out to us. We're here to help!
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            Email: <Link href={`mailto:${config.supportMail}`} color="primary.dark">{config.supportMail}</Link>
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            Phone: <Link href={`tel:${config.phoneNumber}`} color="primary.dark">{config.phoneNumber}</Link>
                        </Typography>
                        <Button variant="contained" color="primary" href="/contact" sx={{ marginTop: 2 }}>
                            Contact Us
                        </Button>
                    </Grid>

                    {/* Stay Updated Section */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: 2 }}>
                            Stay Updated
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            Join our mailing list to receive the latest updates, resources, and special offers from Glassyfied.
                        </Typography>
                        <Button variant="outlined"
                            // href="/newsletter-signup"
                            sx={{
                                marginTop: 2,
                                color: "primary.dark",
                                borderColor: "primary.dark"
                            }}
                            onClick={() => handlePopupOpen("login")}
                        >
                            Sign Up for Updates
                        </Button>
                    </Grid>
                </Grid>
            </Container>
            <PopupModal
                activePopup={activePopup}
                handlePopupClose={handlePopupClose}
                handlePopupOpen={handlePopupOpen}
            />
        </Box>
    );
};

export default ContactInfo;
